import Minus from '!svg-react-loader?!images-react-svg/icons/icon-minus.svg';
import Plus from '!svg-react-loader?!images-react-svg/icons/icon-plus.svg';

import React from 'react';
import classNames from 'classnames';
import { bool, func, number } from 'prop-types';

export const INCREMENT_CLASS_NAME = 'QuantityInput__increment';
export const DECREMENT_CLASS_NAME = 'QuantityInput__decrement';

export default class QuantityInput extends React.Component {
  static propTypes = {
    compact: bool,
    controls: bool,
    defaultQuantity: number,
    disableDecrement: bool,
    disableIncrement: bool,
    maximum: number,
    minimum: number,
    onChange: func,
    readOnly: bool,
    value: number.isRequired,
  };

  static defaultProps = {
    color: null,
    compact: false,
    controls: true,
    disableDecrement: false,
    disableIncrement: false,
    maximum: Infinity,
    minimum: 0,
    readOnly: false,
  };

  UNSAFE_componentWillMount() {
    this.setDefaultValue();
  }

  componentDidUpdate() {
    this.setDefaultValue();
  }

  updateQuantity = newValue => {
    this.props.onChange && this.props.onChange(newValue);
  };

  setDefaultValue = () => {
    const { defaultQuantity, value } = this.props;
    value < defaultQuantity && this.updateQuantity(this.props.value + 1);
  };

  isDisabled = disableProp => this.props.readOnly || disableProp;

  canIncrement = () => {
    const { disableIncrement, value, maximum } = this.props;
    return !this.isDisabled(disableIncrement) && value < maximum;
  };

  canDecrement = () => {
    const { disableDecrement, value, minimum } = this.props;
    return !this.isDisabled(disableDecrement) && value > minimum;
  };

  decrementValue = () =>
    this.canDecrement() && this.updateQuantity(this.props.value - 1);

  incrementValue = () =>
    this.canIncrement() && this.updateQuantity(this.props.value + 1);

  // this appears to be the best option for preventing
  // the iOS "double tap to zoom" feature on a particular DOM
  // element
  // otherwise, it's very easy to trigger an unwanted zoom
  // by increasing or decreasing a value by >= 2
  handleTouchEnd = event => {
    event.preventDefault();
    event.target.click();
  };

  render() {
    const {
      compact,
      controls,
      disableDecrement,
      disableIncrement,
      readOnly,
      value,
    } = this.props;

    const className = classNames(this.props.className, 'QuantityInput', {
      'QuantityInput--compact': compact,
      'QuantityInput--read-only': readOnly,
      'QuantityInput--no-controls': !controls,
    });

    return (
      <div className={className} onTouchEnd={this.handleTouchEnd}>
        {controls && (
          <div
            data-testid="quantity-input-decrement-button"
            className={classNames(DECREMENT_CLASS_NAME, {
              'QuantityInput__decrement--read-only':
                readOnly || disableDecrement || !this.canDecrement(),
            })}
            onClick={this.decrementValue}
          >
            <Minus className="QuantityInput__icon fs-ignore-rage-clicks" />
          </div>
        )}
        <div className="QuantityInput__value heading--small">{value}</div>
        {controls && (
          <div
            data-testid="quantity-input-increment-button"
            className={classNames(INCREMENT_CLASS_NAME, {
              'QuantityInput__increment--read-only':
                readOnly || disableIncrement || !this.canIncrement(),
            })}
            onClick={this.incrementValue}
          >
            <Plus className="QuantityInput__icon fs-ignore-rage-clicks" />
          </div>
        )}
      </div>
    );
  }
}
